import { render, staticRenderFns } from "./SurveyVars.vue?vue&type=template&id=45003c21"
import script from "./SurveyVars.vue?vue&type=script&lang=js"
export * from "./SurveyVars.vue?vue&type=script&lang=js"
import style0 from "./SurveyVars.vue?vue&type=style&index=0&id=45003c21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports